import axios, { extractData } from '@atheneum/api'
import { extendObservable, computed } from 'mobx'
import reduce from 'lodash/reduce'

class MyProjectsStore {
  constructor (staticData) {
    extendObservable(this, {
      projects: [],
      openIn: '/experts-pipeline',
      required: computed(() =>
        reduce(this.projects, (sum, p) => sum + p.required, 0)
      ),
      interviewed: computed(() =>
        reduce(this.projects, (sum, p) => sum + p.interviewed, 0)
      ),
      delivered: computed(() =>
        reduce(this.projects, (sum, p) => sum + p.delivered, 0)
      ),
      interviewTarget: computed(() =>
        reduce(this.projects, (sum, p) => sum + p.interviewTarget, 0)
      ),
      loading: false
    })
  }

  saveOrder () {
    return axios.put('/api/my-projects-order', {
      order: this.projects.map(p => p.id)
    })
  }

  getAll () {
    this.loading = true
    return axios.get('/api/project/my-projects').then(res => {
      this.projects = extractData(res)
      this.loading = false
      return this.projects
    })
  }
}

export default MyProjectsStore
